module.exports = __webpack_public_path__ + "img/officer.fbff0ebf.png";